import React, { useState } from 'react';

function GunViolenceResources() {
  const [showAllResourcesERPO, setShowAllResourcesERPO] = useState(false);
  const [showAllResourcesSupport, setShowAllResourcesSupport] = useState(false);

  // Emergency hotlines and resources
  const emergencyResources = [
    {
      name: "National Suicide Prevention Lifeline",
      phone: "988",
      textLine: "",
      website: "https://988lifeline.org/",
      description: "Mental health crisis support and suicide prevention"
    },
    {
      name: "Crisis Text Line",
      phone: "",
      textLine: "Text HOME to 741741",
      website: "https://www.crisistextline.org/",
      description: "24/7 text support for crisis situations"
    },
    {
      name: "Disaster Distress Helpline",
      phone: "1-800-985-5990",
      textLine: "Text TalkWithUs to 66746",
      website: "https://www.samhsa.gov/find-help/disaster-distress-helpline",
      description: "Crisis counseling for people experiencing emotional distress related to disasters and traumatic events"
    }
  ];

  // Extreme Risk Protection Order (ERPO) Resources
  const erpoResources = [
    {
      name: "Giffords Law Center: Extreme Risk Protection Orders",
      website: "https://giffords.org/lawcenter/gun-laws/policy-areas/who-can-have-a-gun/extreme-risk-protection-orders/",
      description: "Information about Extreme Risk laws and how they work"
    },
    {
      name: "Everytown: Red Flag Laws",
      website: "https://www.everytown.org/solutions/",
      description: "Overview of red flag laws and their implementation"
    },
    {
      name: "CA Restraining Orders",
      website: "https://selfhelp.courts.ca.gov/GV-restraining-order",
      description: "California's Gun Violence Restraining Order resource site"
    },
    {
      name: "Educational Fund to Stop Gun Violence",
      website: "https://efsgv.org/learn/extreme-risk-laws/",
      description: "Resources about Extreme Risk laws with state-specific information"
    },
    {
      name: "Bloomberg American Health Initiative",
      website: "https://americanhealth.jhu.edu/implementERPO",
      description: "Implementation guides for Extreme Risk Protection Orders"
    }
  ];

  // Support organizations for gun violence survivors
  const supportResources = [
    {
      name: "Everytown for Gun Safety Survivor Network",
      website: "https://everytown.org/survivors/",
      description: "Support network for survivors of gun violence"
    },
    {
      name: "The Rebels Project",
      website: "https://www.therebelsproject.org/",
      description: "Support group for survivors of mass trauma"
    },
    {
      name: "Survivors Empowered",
      website: "https://survivorsempowered.org/",
      description: "Education, advocacy and support for gun violence survivors"
    },
    {
      name: "Coalition to Stop Gun Violence",
      website: "https://www.csgv.org/",
      description: "Advocacy organization for gun violence prevention"
    },
    {
      name: "States United to Prevent Gun Violence",
      website: "https://www.ceasefireusa.org/",
      description: "Coalition of state-based gun violence prevention organizations"
    },
    {
      name: "Giffords: Courage to Fight Gun Violence",
      website: "https://giffords.org/",
      description: "Resources and advocacy for gun violence prevention"
    }
  ];

  // Safety planning tips specific to gun violence threats
  const safetyTips = [
    "If you're concerned about someone with access to firearms who may be a danger to themselves or others, contact local law enforcement",
    "Be aware of your state's Extreme Risk Protection Order (ERPO) or 'red flag' laws that allow temporary removal of firearms",
    "Document concerning behaviors, threats, or incidents involving firearms",
    "Create a safety plan with trusted friends or family members",
    "Identify safe locations that you can go to if you feel unsafe",
    "Keep copies of important documents in a secure, accessible location",
    "Consider speaking with an attorney about legal options in your state",
    "If there are firearms in your home that concern you, learn about safe storage and legal transfer options",
    "Reach out to domestic violence organizations who can help with safety planning"
  ];

  return (
    <div className="card">
      <div className="card-header">
        <h2>Gun Violence Prevention Resources</h2>
        <p className="safety-note">
          <strong>Quick Exit:</strong> Press the "Escape" key or click the "Quick Exit" button at any time to immediately leave this page.
        </p>
      </div>
      <div className="card-body">
        <div className="emergency-resources">
          <h3>Emergency Support Resources</h3>
          <div className="resources-list emergency">
            {emergencyResources.map((resource, index) => (
              <div key={index} className="resource-item emergency">
                <h4>{resource.name}</h4>
                {resource.phone && <p className="phone"><strong>Call:</strong> {resource.phone}</p>}
                {resource.textLine && <p className="text-line"><strong>Text:</strong> {resource.textLine}</p>}
                <p className="description">{resource.description}</p>
                <a href={resource.website} target="_blank" rel="noopener noreferrer" className="resource-link">
                  Visit Website
                </a>
              </div>
            ))}
          </div>
        </div>

        <div className="safety-planning">
          <h3>Safety Planning Tips</h3>
          <ul className="safety-tips-list">
            {safetyTips.map((tip, index) => (
              <li key={index} className="safety-tip">{tip}</li>
            ))}
          </ul>
        </div>

        <div className="erpo-resources">
          <h3>Extreme Risk Protection Orders (ERPOs) / "Red Flag" Laws</h3>
          <p>
            Extreme Risk Protection Orders are legal tools that temporarily remove firearms from individuals
            who may present a danger to themselves or others. These laws exist in many states under different names.
          </p>
          
          <div className="resources-list erpo">
            {(showAllResourcesERPO ? erpoResources : erpoResources.slice(0, 3)).map((resource, index) => (
              <div key={index} className="resource-item support">
                <h4>{resource.name}</h4>
                <p className="description">{resource.description}</p>
                <a href={resource.website} target="_blank" rel="noopener noreferrer" className="resource-link">
                  Visit Website
                </a>
              </div>
            ))}
          </div>
          
          {erpoResources.length > 3 && (
            <button 
              className="btn btn-outline"
              onClick={() => setShowAllResourcesERPO(!showAllResourcesERPO)}
            >
              {showAllResourcesERPO ? 'Show Fewer Resources' : 'Show More Resources'}
            </button>
          )}
        </div>

        <div className="support-resources">
          <h3>Support Organizations</h3>
          <div className="resources-list support">
            {(showAllResourcesSupport ? supportResources : supportResources.slice(0, 3)).map((resource, index) => (
              <div key={index} className="resource-item support">
                <h4>{resource.name}</h4>
                <p className="description">{resource.description}</p>
                <a href={resource.website} target="_blank" rel="noopener noreferrer" className="resource-link">
                  Visit Website
                </a>
              </div>
            ))}
          </div>
          
          {supportResources.length > 3 && (
            <button 
              className="btn btn-outline"
              onClick={() => setShowAllResourcesSupport(!showAllResourcesSupport)}
            >
              {showAllResourcesSupport ? 'Show Fewer Resources' : 'Show More Resources'}
            </button>
          )}
        </div>

        <div className="documentation">
          <h3>Documentation for Legal Proceedings</h3>
          <p>
            If you're concerned about someone with access to firearms who may be a danger to themselves or others,
            documenting incidents can be critical for obtaining an Extreme Risk Protection Order or other legal protection.
          </p>
          <div className="documentation-tips">
            <h4>What to Document:</h4>
            <ul>
              <li>Specific threats involving weapons or firearms</li>
              <li>Observable signs of mental health crisis or instability</li>
              <li>Incidents of violence or aggression</li>
              <li>Statements about harming oneself or others</li>
              <li>Unsafe handling of firearms</li>
              <li>Recent acquisition of firearms during a crisis</li>
              <li>History of substance abuse combined with access to firearms</li>
            </ul>
          </div>
        </div>

        <div className="truth-credo">
          <p>
            By taking action to document threats and seek legal protection, you are transforming fear into courage.
            Taking thoughtful, measured steps to protect yourself and others is an act of wisdom and virtue.
          </p>
        </div>
      </div>
    </div>
  );
}

export default GunViolenceResources;